import Main from './main';
import Edit from './edit';
import Single from './single';
import ListCompany from './listCompany';
import Answers from './answers';
import AnswersEdit from './answersedit';
import AnswersPrint from './print';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: 'answers/:id/new',
    Component: AnswersEdit,
    props: {
      exact: true,
    },
  },
  {
    path: 'answers/:id/:idCompany/new',
    Component: AnswersEdit,
    props: {
      exact: true,
    },
  },
  {
    path: 'answers/:id/print',
    Component: AnswersPrint,
    props: {
      exact: true,
    },
  },
  {
    path: 'answers/:id',
    Component: Answers,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/edit',
    Component: Edit,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/list_company',
    Component: ListCompany,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id',
    Component: Single,
    props: {
      exact: true,
    },
  },
  {
    path: '/new',
    Component: Edit,
    props: {
      isNew: true,
    },
  },
];

export default routes;
